import React from 'react';

/**
 * #278 — Stepper visual do ciclo de vida da NC (inspirado no teardown VisionQ).
 * Mostra de relance em que etapa a NC está. É DERIVADO do workflow_status —
 * não muda nenhuma lógica nem dispara nada (front-only, leitura).
 *
 * Caminho oficial (v3.4.0): Rascunho → Aberta → Em Análise → Aguard. aprovação
 * → Aprovada → Encerrada. 'rejeitada' é ramo terminal (nó vermelho ao final).
 * Status legados (v2.0) são normalizados pro caminho oficial.
 */

const STEPS = [
  { key: 'rascunho', label: 'Rascunho' },
  { key: 'aberta', label: 'Aberta' },
  { key: 'em_analise', label: 'Em análise' },
  { key: 'aguardando_aprovacao', label: 'Aguard. aprovação' },
  { key: 'aprovada', label: 'Aprovada' },
  { key: 'encerrada', label: 'Encerrada' },
];

// status legados → caminho oficial
const ALIAS = {
  aprovado: 'aprovada',
  reprovado: 'rejeitada',
  em_revisao: 'em_analise',
};

const DONE = '#0d7c3f';      // verde do app (concluído / etapa atual)
const PENDING = '#cbd5e1';   // trilho/borda das etapas futuras
const PENDING_TXT = '#94a3b8';
const REJECT = '#dc2626';

function NCStatusStepper({ currentStatus }) {
  const status = ALIAS[currentStatus] || currentStatus || 'rascunho';
  const rejeitada = status === 'rejeitada';
  // 'rejeitada' não está no caminho oficial → ancora a barra em "Aguard. aprovação"
  const refKey = rejeitada ? 'aguardando_aprovacao' : status;
  let idx = STEPS.findIndex((s) => s.key === refKey);
  if (idx < 0) idx = 0; // status desconhecido → mostra no início, sem quebrar

  const circle = (bg, border, color, ring) => ({
    width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: bg, border: `2px solid ${border}`, color,
    fontSize: 13, fontWeight: 700, lineHeight: 1,
    boxShadow: ring ? `0 0 0 4px ${DONE}22` : 'none',
  });

  return (
    <div
      role="group"
      aria-label={`Andamento da não conformidade: etapa ${STEPS[idx].label}${rejeitada ? ' (rejeitada)' : ''}`}
      style={{
        display: 'flex', alignItems: 'flex-start', margin: '0 0 1.25rem',
        padding: '0.75rem 0.25rem', overflowX: 'auto',
      }}
    >
      {STEPS.map((step, i) => {
        const done = i <= idx;
        const isCurrent = i === idx && !rejeitada;
        const last = i === STEPS.length - 1;
        return (
          <React.Fragment key={step.key}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 66, flex: '0 0 auto' }}>
              <div style={done
                ? circle(DONE, DONE, '#fff', isCurrent)
                : circle('#fff', PENDING, PENDING_TXT, false)}>
                {done && !isCurrent
                  ? <span className="material-symbols-outlined" style={{ fontSize: 17 }}>check</span>
                  : <span>{i + 1}</span>}
              </div>
              <span style={{
                marginTop: 6, fontSize: 11, textAlign: 'center', whiteSpace: 'nowrap',
                fontWeight: isCurrent ? 700 : 500,
                color: done ? '#0f172a' : PENDING_TXT,
              }}>
                {step.label}
              </span>
            </div>
            {!last && (
              <div style={{
                flex: '1 1 auto', minWidth: 16, height: 2, marginTop: 13,
                background: i < idx ? DONE : PENDING,
              }} />
            )}
          </React.Fragment>
        );
      })}

      {rejeitada && (
        <>
          <div style={{ flex: '1 1 auto', minWidth: 16, height: 2, marginTop: 13, background: REJECT }} />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 66, flex: '0 0 auto' }}>
            <div style={circle(REJECT, REJECT, '#fff', false)}>
              <span className="material-symbols-outlined" style={{ fontSize: 17 }}>close</span>
            </div>
            <span style={{ marginTop: 6, fontSize: 11, fontWeight: 700, color: REJECT, whiteSpace: 'nowrap' }}>
              Rejeitada
            </span>
          </div>
        </>
      )}
    </div>
  );
}

export default NCStatusStepper;
